import React from 'react'
import loader from "../assets/images/listloader.svg";

const ButtonLoader = () => {
    return (
        <img height="20" src={loader} alt=""/>
    )
}

export default ButtonLoader
